import { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { ApiError, fetchAuthMe } from '../api/auth'
import { useAuth } from '../hooks/useAuth'

/** Firebase session ok → open-signup admit (if enabled) → allowlist gate. */
export function RequireAllowlist() {
  const { user, loading: authLoading, completeOpenSignup } = useAuth()
  const [state, setState] = useState<'loading' | 'ok' | 'denied' | 'error'>('loading')

  useEffect(() => {
    if (authLoading || !user) return
    let cancelled = false
    void (async () => {
      try {
        await completeOpenSignup()
        await fetchAuthMe()
        if (!cancelled) setState('ok')
      } catch (e) {
        if (cancelled) return
        if (e instanceof ApiError && e.status === 403) setState('denied')
        else setState('error')
      }
    })()
    return () => {
      cancelled = true
    }
  }, [authLoading, user, completeOpenSignup])

  if (authLoading || state === 'loading') {
    return (
      <div className="shell">
        <p className="muted">Checking access…</p>
      </div>
    )
  }
  if (state === 'denied') return <Navigate to="/not-yet" replace />
  if (state === 'error') {
    return (
      <div className="shell">
        <p className="login-error" role="alert">
          Couldn&apos;t verify access. Try signing in again.
        </p>
      </div>
    )
  }
  return <Outlet />
}
